<template>
  <v-container fluid class="orderDetail">
    <v-row>
      <v-col>
        <h2 class="subtitle">Référence / Nom de la commande : {{order.ref}}</h2>
      </v-col>
    </v-row>
    <v-row>
      <template v-for="block in blocks">
        <v-col
          cols="4"
          class="pb-0 pt-0"
          :key="block.id"
          v-if="block.fieldObject && block.fieldObject.type_id!='upload'"
        >
          <v-row>
            <v-col cols="6">
              <div class="font-weight-medium grey--text mr-2">{{block.fieldObject.name}} :</div>
            </v-col>
            <v-col cols="6">
              <div class="font-weight-medium black--text">{{getValue(block)}}</div>
            </v-col>
          </v-row>
        </v-col>
      </template>
    </v-row>
    <v-row>
      <v-col cols="12" class="fields">
        <template v-for="block in blocks">
          <div
            class="field mb-4"
            :key="block.id"
            v-if="block.fieldObject && block.fieldObject.type_id=='upload'"
          >
            <div class="font-weight-medium grey--text mr-2">{{block.fieldObject.name}} :</div>
            <template v-if="Array.isArray(getValue(block))">
              <div v-for="file in getValue(block)" :key="file.id">
                <img :src="$assets.url(file.url)" height="40" width="auto" />
              </div>
            </template>
            <div v-else>
              <img :src="$assets.url(getValue(block).url)" height="40" width="auto" />
            </div>
          </div>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  computed: {
    ...mapState("orderForm", ["order", "blocks"])
  },
  methods: {
    getValue(block) {
      if (block.data) {
        if (block.fieldObject && block.fieldObject.type_id == "date") {
          let d = moment(new Date(block.data.value));
          return block.fieldObject.config.hour
            ? d.format("DD/MM/YYYY HH:mm")
            : d.format("DD/MM/YYYY");
        }
        return block.data.value;
      }
      return null;
    }
  }
};
</script>

<style lang="less" scoped>
.orderDetail {
  /deep/ .fields {
    &.cols {
      columns: 3;
    }
    .field {
      display: flex;
      flex-direction: row;
    }
  }
}
</style>